import { Chip, Stack, Typography } from '@mui/material';

import { TableColumnActionModel } from '../../Models/TableColumnModel';

type ActionsInputContentProps = {
	value: TableColumnActionModel[] | undefined;
};

export default function ActionsInputContent({ value }: ActionsInputContentProps) {
	if (!value || value.length === 0) {
		return <Typography variant="body2">No actions configured</Typography>;
	}

	return (
		<Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
			{value.map((action, index) => (
				<Chip key={index} label={action.Label} size="small" variant="outlined" />
			))}
		</Stack>
	);
}
